import React from 'react';
import { RootState } from 'store';
import { connect } from 'react-redux';
import loading from 'assets/loading.gif';

const mapStateToProps = (state: RootState) => ({
  requests: state.loader.requests,
});

type Props = ReturnType<typeof mapStateToProps>;

const Loading: React.FC<Props> = (props) => {
  return props.requests.length > 0 ? (
    <div style={{ zIndex: 1500, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.1)', position: 'fixed' }}>
      <img
        src={loading}
        alt="loading"
        style={{
          height: '48px',
          width: '48px',
          position: 'absolute',
          margin: 'auto',
          left: 0,
          right: 0,
          bottom: 0,
          top: 0,
        }}
      />
    </div>
  ) : null;
};

interface ComponentLoaderProps {
  backgroundEffect?: boolean;
  loaderRelativePosition?: boolean;
}

const ComponentLoading: React.FC<ComponentLoaderProps> = (props) => {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        textAlign: 'center',
        backgroundColor: props.backgroundEffect ? 'rgba(0,0,0,0.1)' : 'none',
        position: 'relative',
      }}
    >
      <img
        src={loading}
        alt="loading"
        style={{
          height: '48px',
          width: '48px',
          margin: 'auto',
          inset: 0,
          position: props.loaderRelativePosition ? 'relative' : 'absolute',
        }}
      />
    </div>
  );
};

export const Loader = connect(mapStateToProps)(Loading);
export const ComponentLoader = ComponentLoading;
